import { render, staticRenderFns } from "./AdItemPlacementContextHandler.vue?vue&type=template&id=e5bf2a8a&scoped=true&"
import script from "./AdItemPlacementContextHandler.vue?vue&type=script&lang=ts&"
export * from "./AdItemPlacementContextHandler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5bf2a8a",
  null
  
)

export default component.exports